module.exports = __webpack_public_path__ + "static/media/adesivo_reluz.c0f519aa.png";